import {
  ComponentBuilder,
  FunctionComponent
} from '../../component-builder/types';
import { DisplayConfigType } from 'formats/display/lib/config';
import { Component as Creative } from './component';
import { Component as DiscoverBlockCreative } from './discover-block-creative/component';

export class CreativeBuilder implements ComponentBuilder<DisplayConfigType> {
  isInjectable(adContext: AdContext, formatConfig: DisplayConfigType): boolean {
    return (
      formatConfig?.creative?.url != null ||
      formatConfig?.creative?.creative != undefined
    );
  }

  build(
    adContext: AdContext,
    formatConfig: DisplayConfigType
  ): FunctionComponent {
    return formatConfig?.creative?.creative != undefined
      ? DiscoverBlockCreative
      : Creative;
  }
}
